module.exports = __webpack_public_path__ + "static/media/sy.73690f50.svg";